import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import thunk from "redux-thunk";
import { _window } from "../globalConsts";

import LoginReducer from "./login/root";
import x2yReducer from "./x2y/reducer";

import bugReportReducer from "./bugReport/reducer";
import dataSourcesReducer from "./datasources/reducer";
import favouriteTemplatesReducer from "./favouriteTemplates/reducer";
import functionsReducer from "./functions/reducers/root";
import functionTemplatesReducer from "./functionTemplates/reducers/root";
import globalFetchReducer from "./globalFetch/reducer";
import globalStateReducer from "./globalState/reducer";
import hegMappingReducer from "./hegMapping/reducer/root";
import impersonationReducer from "./impersonation/reducer";
import localizationReducer from "./localization/reducer";
import modulesReducer from "./modules/reducer";
import notificationsReducer from "./notifications/reducer";
import personalizationReducer from "./personalization/reducer";
import tableDataReducer from "./tableData/reducer";
import templateBuilderReducer from "./templateBuilder/reducer";
import templateMetadataReducer from "./templateMetadata/reducer";
import userFiltersReducer from "./userFilters/reducer";
import userReducer from "./user/reducer";
import overviewTablesReducer from "./overviewTables/reducer";

import signalRRegisterCommands from "./signalRRegisterCommands";
import { signalRMiddleware } from "./middleware/signalRMiddleware";
import subsequentDispatchMiddleware from "./middleware/subsequentDispatchMiddleware";

const reducers = {
  bugReport: bugReportReducer,
  datasources: dataSourcesReducer,
  favouriteTemplates: favouriteTemplatesReducer,
  functions: functionsReducer,
  functionTemplates: functionTemplatesReducer,
  globalFetch: globalFetchReducer,
  globalState: globalStateReducer,
  hegMapping: hegMappingReducer,
  impersonation: impersonationReducer,
  localization: localizationReducer,
  login: LoginReducer,
  modules: modulesReducer,
  notifications: notificationsReducer,
  overviewTables: overviewTablesReducer,
  personalization: personalizationReducer,
  templateMetadata: templateMetadataReducer,
  templateBuilder: templateBuilderReducer,
  user: userReducer,
  userFilters: userFiltersReducer,
  x2y: x2yReducer,
  tableData: tableDataReducer,
};

const enhancers = [];

// In development, use the browser's Redux dev tools extension if installed
const reduxDevtools = _window.__REDUX_DEVTOOLS_EXTENSION__;
const reduxDevtoolsConfig = {};
if (
  process.env.NODE_ENV === "development" &&
  _window?.__REDUX_DEVTOOLS_EXTENSION__
) {
  enhancers.push(reduxDevtools && reduxDevtools(reduxDevtoolsConfig));
}

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = _window.initialReduxState;

const middleware = [
  thunk,
  subsequentDispatchMiddleware,
  signalRMiddleware,
] as const;

const rootReducer = combineReducers(reducers);

export const store = createStore(
  rootReducer,
  initialState,
  compose(applyMiddleware(...middleware), ...enhancers)
);

export type StoreType = typeof store;

signalRRegisterCommands(store.dispatch);
